import { createApp } from 'vue'
import SecondConfirmation from './second-confirmation.vue'
export const useSecondConfirmation = options => {
  const { title, message, confirmText, cancelText, icon = null } = options
  return new Promise((resolve, reject) => {
    // 实例化组件，createApp第二个参数是props
    const confirmInstance = createApp(SecondConfirmation, {
      open: true,
      title: title || '温馨提示',
      message: message || '你有未保存的更改，确定关闭？',
      confirmText,
      cancelText,
      icon,
      onConfirm: () => {
        resolve(true)
        unmount()
      },
      onCancel: () => {
        reject(new Error())
        unmount()
      }
    })

    // 卸载组件
    const unmount = () => {
      confirmInstance.unmount()
      document.body.removeChild(parentNode)
    }
    // 创建一个挂载容器
    const parentNode = document.createElement('div')
    document.body.appendChild(parentNode)
    // 挂载组件
    confirmInstance.mount(parentNode)
  })
}
